import React from 'react';
import { useIntl } from 'ha/i18n';
import { CurrencyFormat } from '@ha/intl';
import { useSelector } from 'react-redux';
import { getCurrency } from 'ha/pages/Listing/reducer';
import { DesiredDates } from 'ha/models/BookingDates/types';
import { CostRow } from './components/CostRow';

interface Props {
  firstInstalment: number;
  desiredDates: DesiredDates;
  instalmentsPrices:
    | {
        caption: string;
        crossedPrice: string;
        value: string;
      }[]
    | null;
}
const InstalmentsList: React.FC<Props> = ({
  instalmentsPrices,
  firstInstalment,
  desiredDates,
}) => {
  const { T, formatDate, formatCurrency } = useIntl();
  const currency = useSelector(getCurrency);
  return (
    <React.Fragment>
      <CostRow
        title={`${formatDate('MMMM YYYY', desiredDates.startDate!)} (${T(
          'payment_overview.rent.first_payment.paid_to_HA',
        )})`}
        value={formatCurrency(
          firstInstalment,
          currency,
          currency === 'EUR'
            ? CurrencyFormat.WITH_CURRENCY_SYMBOL_NO_FRACTION_NO_GROUPING
            : CurrencyFormat.WITH_CURRENCY_CODE_NO_FRACTION_NO_GROUPING,
        )}
      />
      {instalmentsPrices?.map(item => (
        <CostRow
          title={item.caption}
          crossedValue={item.crossedPrice}
          value={item.value}
        />
      ))}
    </React.Fragment>
  );
};
export { InstalmentsList };
